import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IQPPSetupFieldsPanel { selectedTaxYear: number | null }
export const QPPSetupFieldsPanel: FC<IQPPSetupFieldsPanel> = ({ selectedTaxYear }) => {
	return (
		<div>
			{/* <RHookFormTextFieldWithLabel
				label="Annual Max_Pensionable Earnings"
				id="annualMaxPensionableEarnings"
				testId={`annual-Max-Pensionable-Earnings`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Basic Exemption for the year"
				id="basicExemptionForTheYear"
				testId={`Basic-Exemption-for-the-year`}
				labelPosition={LabelPosition.Top}
			/> */}
			<RHookFormNumberFieldWithLabel
				label="Annual Max_Pensionable Earnings"
				id="annualMaxPensionableEarnings"
				testId={`annual-Max-Pensionable-Earnings`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Basic Exemption for the year"
				id="basicExemptionForTheYear"
				testId={`Basic-Exemption-for-the-year`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			{/* <FieldWrapper>
				<FieldLayout
					label="Employee Contribution Rate"
					testId="Employee-Contribution-Rate"
					labelPosition={LabelPosition.Top}
				>
					<RHookFormNumericFormatTextField
						id={"employeeContributionRate"}
						testId={`Employee-Contribution-Rate`}
						defaultValue={"0.00"}
						textAlign={"end"}
					/>
				</FieldLayout>
			</FieldWrapper>
			<FieldWrapper>
				<FieldLayout
					label="Employer Contribution Rate"
					testId="Employer-Contribution-Rate"
					labelPosition={LabelPosition.Top}
				>
					<RHookFormNumericFormatTextField
						id={"employerContributionRate"}
						testId={`Employer-Contribution-Rate`}
						defaultValue={"0.00"}
						textAlign={"end"}
					/>
				</FieldLayout>
			</FieldWrapper> */}
			<RHookFormNumberFieldWithLabel
				id={"employeeContributionRate"}
				label="Employee Contribution Rate"
				testId="Employee-Contribution-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"employerContributionRate"}
				label="Employer Contribution Rate"
				testId="Employer-Contribution-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"employeeMaxContribution"}
				label="Employee Max. Contribution"
				testId="employee-Max-Contribution"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			{selectedTaxYear !== null && selectedTaxYear >= 2024 && <RHookFormNumberFieldWithLabel
				id={"annualSecondQppMaxPensionableEarnings"}
				label="Annual Second Qpp Max Pensionable Earnings"
				testId="annual-Second-Qpp-Max-Pensionable-Earnings"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>}
			{selectedTaxYear !== null && selectedTaxYear >= 2024 && <RHookFormNumberFieldWithLabel
				id={"secondQppContributionRate"}
				label="Second Qpp Contribution Rate"
				testId="second-Qpp-Contribution-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>}
			{selectedTaxYear !== null && selectedTaxYear >= 2024 && <RHookFormNumberFieldWithLabel
				id={"secondQppMaxContribution"}
				label="Second Qpp Max Contribution"
				testId="second-Qpp-Max-Contribution"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>}
			<RHookFormNumberFieldWithLabel
				id={"cpp_qpp_k2_variable"}
				label="K2 Variable"
				testId="cpp_qpp_k2_variable"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
